module.exports = __webpack_public_path__ + "img/Tessellate14.64e5e448.jpg";